import { environment } from '../../../environments/environment';

(function () {
    'use strict';

    angular
        .module('aricControllers')
        .directive('aricControlOwnerCard', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                owner:              '=',
                readOnly:           '=',
                isMultiSelect:      '=',
                toSendReminder:     '&'
            },
            restrict: 'AE',
            templateUrl: require('./aricControlOwnerCard.tpl.html'),
            controller: ['$scope', '$state', '$timeout', '$window', 'aricService', function ($scope, $state, $timeout, $window, aricService) {

                // Reminder flags
                $scope.sendReminderError = null;
                $scope.sendReminderSuccess = false;
                $scope.sendingReminderInProgress = false;
                var sendReminderSuccessTimeout = null;
                var unlockCertificationSuccessTimeout = null;

                // Show or hide actions
                $scope.card_onClick = function ($event) {
                    if ($scope.readOnly || $scope.isMultiSelect) return;

                    if (shouldShowControlsOnCardClick($scope.owner.ControlOwnerStatusValue)) {
                        $scope.goToOwnerControls($event);
                    } else {
                        $scope.showOrHideActions($event);
                    }

                    $event.stopPropagation();
                };

                $scope.showOrHideActions = function ($event) {
                    if ($scope.readOnly || $scope.isMultiSelect) return;
                    $scope.displayActions = !$scope.displayActions;
                    $event.stopPropagation();
                };

                // Go to assessor risks
                $scope.goToOwnerControls = function ($event) {

                    $event.stopPropagation();

                    var facetFilters = 'OwnerIDForFacets%3D' + $scope.owner.ItemPersonID + ';IsClosedForFacets%3DNo';
                    var url = environment.govUrl + '/Search/Control?facets=';
                    url += facetFilters;
                    $window.open(url, '_self');
                };

                // Send reminder to owner
                $scope.sendReminderToOwner = function () {
                    $scope.sendReminderError = null;
                    $scope.sendReminderSuccess = null;
                    $scope.sendingReminderInProgress = true;
                    if (sendReminderSuccessTimeout !== null) {
                        $timeout.cancel(sendReminderSuccessTimeout);
                    }
                    sendReminderSuccessTimeout = null;
                    $scope.toSendReminder()
                        .then(function () {
                            $scope.sendReminderError = null;
                            $scope.sendReminderSuccess = true;
                            sendReminderSuccessTimeout = $timeout(function () {
                                $scope.sendReminderSuccess = false;
                                $scope.displayActions = false;
                            }, 1500);
                        })
                        .catch(function () {
                            $scope.sendReminderError = "The reminder couldn't be sent. Please try again later.";
                        })
                        .finally(function () {
                            $scope.sendingReminderInProgress = false;
                        });
                };

                // Unlock certification
                $scope.unlockCertification = function () {
                    $scope.unlockCertificationError = null;
                    $scope.unlockCertificationSuccess = null;
                    $scope.unlockCertificationInProgress = true;
                    if (unlockCertificationSuccessTimeout !== null) {
                        $timeout.cancel(unlockCertificationSuccessTimeout);
                    }
                    unlockCertificationSuccessTimeout = null;
                    aricService
                        .unlockCertificationForOwner($scope.owner)
                        .then(function (updatedOwner) {
                            $scope.unlockCertificationError = null;
                            $scope.unlockCertificationSuccess = true;
                            unlockCertificationSuccessTimeout = $timeout(function () {
                                _.assign($scope.owner, updatedOwner);
                                $scope.unlockCertificationSuccess = false;
                                $scope.displayActions = false;
                            }, 1500);
                        })
                        .catch(function () {
                            $scope.unlockCertificationError = "Certification couln't be unlocked. Please try again later.";
                        })
                        .finally(function () {
                            $scope.unlockCertificationInProgress = false;
                        });
                };

                // Get Unlock Certification Tooltip Msg
                $scope.getUnlockCertificationTooltipMsg = function () {
                    if ($scope.unlockCertificationError) return $scope.unlockCertificationError;
                    if ($scope.unlockCertificationSuccess === true) return 'Certification unlocked successfully';

                    return 'Unlock Certification';
                };

                // Show Send Reminder Action
                $scope.showSendReminderAction = function () {
                    var ownerStatusValue = $scope.owner.ControlOwnerStatusValue;

                    if (ownerStatusValue === 'ReadyForCertification') return true;
                    if (ownerStatusValue === 'CertificationInProgress') return true;

                    return false;
                };

                // Show Unlock Certification Action
                $scope.showUnlockCertificationAction = function () {
                    var ownerStatusValue = $scope.owner.ControlOwnerStatusValue;

                    if (ownerStatusValue === 'CertificationToReview') return true;
                    if (ownerStatusValue === 'Completed') return true;

                    return false;
                };

                function shouldShowControlsOnCardClick(ownerStatusValue) {
                    if (ownerStatusValue === 'ReadyForCertification') return false;
                    if (ownerStatusValue === 'CertificationInProgress') return false;
                    if (ownerStatusValue === 'CertificationToReview') return false;
                    if (ownerStatusValue === 'Completed') return false;

                    return true;
                }
            }],
            link: function (scope, element, attrs) {
                //Display or not actions
                scope.displayActions = false;
            }
        };
    }
})();
